<template>
  <div class="dashBoard-topBox">
    <div class="title">
      常用<img src="~@/assets/img/setting.png" alt="" @click="setting" />
    </div>
    <div class="operation">
      <div
        class="group"
        v-for="(item, index) in menus"
        :key="index"
        @click="goNextPage(item)"
        :class="index > 3 ? 'grouped' : ''"
      >
        <img
          :src="require(`../../assets/home/img/${item.attachment}`)"
          class="top"
          alt=""
          v-if="item.type == 'apply'"
        />
        <span v-else>
          <img
            class="top"
            :src="`${apiBaseUrlDownload}jksaas-mgt/mgt${item.attachment}`"
            v-if="item.attachment"
          />
          <img
            src="~@/assets/home/img/2.png"
            class="top"
            alt=""
            v-else
          />
        </span>
        <span class="bottom">{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { produceAxios, getAction } from "@/api/manage";
import { getAction2 } from "@/api/newManage";

import { apiBaseUrlDownload } from "@/utils/request";
import { LING_YANG_ROLE_TYPE } from "@/store/mutation-types";
export default {
  created() {},
  props: {
    formdata: {
      type: Object,
      default() {
        return {};
      },
    },
    // menus: Array
  },
  data() {
    return {
      apiBaseUrlDownload,
      menus: [
        {
          name: "待我审批",
          number: "",
          applyType: "waiterDeal",
        },
        {
          name: "已审批",
          number: "",
          applyType: "alreadyDeal",
        },
        {
          name: "已发起",
          number: "",
          applyType: "alreadyLaunch",
        },
        {
          name: "我收到的",
          number: "",
          applyType: "copyToMe",
        },
        {
          name: "我收到的",
          number: "",
          applyType: "copyToMe",
        },
        {
          name: "我收到的",
          number: "",
          applyType: "copyToMe",
        },
      ],
    };
  },

  created() {
    this.menus = [];
    let antelopeFlag = this.$ls.get(LING_YANG_ROLE_TYPE);
      let params = { useScope: "app",systemType:"3"};
      if (antelopeFlag) {
        params.antelopeFlag = antelopeFlag;
      }
    getAction2("/sys/home/queryMyself", params).then((res) => {
      this.menus = res.result;
    });
  },
  methods: {
    goNextPage(item) {
      let pathUrl = item.path;
      let paramsObj = {
        navTitle: item.name,
        applyType: item.type,
      };
      this.$router.push({
        path: pathUrl,
        query: paramsObj,
      });
    },
    setting() {
      this.$router.push("/commonSettings");
    },
  },
};
</script>

<style lang="scss" scoped>
.dashBoard-topBox {
  background: #ffffff;
  margin-top: 0.1rem;
  padding: 0.16rem;
  .title {
    height: 0.14rem;
    font-size: 0.14rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #888888;
    display: flex;
    justify-content: space-between;
    img {
      width: 0.15rem;
      height: 0.15rem;
    }
  }
  .operation:after {
    content: "";
    flex: auto;
  }
  .operation {
    display: flex;
    justify-content: space-between;
    margin-top: 0.2rem;
    flex-wrap: wrap;
    .grouped {
      margin-top: 0.3rem;
    }
    .group {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: left;
      width: 25%;
      padding: 0 0.05rem;
      .top {
        width: 0.27rem;
        height: 0.27rem;
      }
      .bottom {
        font-size: 0.14rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #191f25;
      }
    }
  }
}
</style>
